module.exports = __webpack_public_path__ + "static/img/icon_share_facebook.e670c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_share_facebook.png
// module id = 4nBY
// module chunks = 10